import routes from '../routes';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';
import VisualSearchView from '../../AdHocTools/VisualSearch/VisualSearch';
import AdHocTools from '../../AdHocTools/AdHocTools';
import MatchesView from '../../AdHocTools/Matches/MatchesView';
import MatchesStats from '../../AdHocTools/Stats/MatchesStats';
import MatchInfo from '../../AdHocTools/Matches/components/MatchInfo';


const moduleRoutes: RoutePathsFn = () => ([
  {
    paths: [routes.VISUAL_SEARCH],
    component: VisualSearchView,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  },
  {
    paths: [routes.MANUALSEARCH],
    component: AdHocTools,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  },
  {
    paths: [routes.REKOGNITION, routes.MATCHESVIEW, routes.MATCHESVIEWBIOMETRICA],
    component: MatchesView,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  },
  {
    paths: [routes.MATCHESSTATS],
    component: MatchesStats,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.MATCHESADHOC, routes.MATCHESCHILD, routes.MATCHESBIOMETRICA],
    component: MatchInfo,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  }
]);

export const searchModule = (): IRouteModule => ({
  name: RoutesModules.SEARCH,
  routes: moduleRoutes(),
  navbar: routes.REKOGNITION,
  sidebar: [
    {
      navTitle: 'Manual Search',
      route: routes.MANUALSEARCH
    },
    {
      navTitle: 'Reverse Image Search',
      route: routes.VISUAL_SEARCH,
      hideOnMobile: true
    },
    {
      navTitle: 'Matches',
      route: routes.MATCHESVIEW,
      isMainPath: true
    },
    {
      navTitle: 'Biometrica',
      route: routes.MATCHESVIEWBIOMETRICA,
      hideOnMobile: true
    },
    {
      navTitle: 'Stats',
      route: routes.MATCHESSTATS,
      hideOnMobile: true
    },
  ]
});